import * as ActionTypes from '../../actions/allActions'

const createAccountInit = { }
const createAccount = (state = createAccountInit, action) => {
	switch (action.type) {
		case ActionTypes.SIGNUP_SUCCESS:
			return { ...state, ...action.data.data.attributes }
		case ActionTypes.LOGOUT:
			return createAccountInit
		default:
			return state
	}
}

export default createAccount


// WEBPACK FOOTER //
// ./src/reducers/metadata/createAccount.js